import { useSignal } from "@preact/signals";
import { PreactRouter, useRouteState } from "bunfx";
import { render } from "preact";
import { useEffect, useRef } from "preact/hooks";
import { FeedbackWidget } from "./components/ui/feedback-widget";
import { routes } from "./pages";

function CurrentPage() {
  const { current } = useRouteState().value;
  if (!current) {
    return null;
  }
  if (current.type === "page") {
    const { Page, key, ...props } = current;
    return <Page key={key} {...props} />;
  }
  if (current.type === "error") {
    return (
      <div class="p-8">
        <h1 class="text-red-600 text-2xl">Error</h1>
        <p>{current.error.toString()}</p>
      </div>
    );
  }
  return null;
}

/** Delay before showing loading indicator (ms). Prevents flash for fast navigations. */
const LOADING_DELAY = 750;

function PageLoadingIndicator() {
  const routeState = useRouteState().value;
  const showIndicator = useSignal(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (routeState.loading) {
      // Start timer to show indicator after delay
      timeoutRef.current = setTimeout(() => {
        showIndicator.value = true;
      }, LOADING_DELAY);
    } else {
      // Clear timer and hide indicator
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      showIndicator.value = false;
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [routeState.loading]);

  if (!showIndicator.value) {
    return null;
  }
  return (
    <div class="fixed top-0 left-0 right-0 h-1 bg-primary-500 animate-pulse" />
  );
}

function App() {
  return (
    <PreactRouter
      routes={routes}
      notFoundRoute="/not-found"
      loginRoute="/login"
    >
      <PageLoadingIndicator />
      <CurrentPage />
      <FeedbackWidget />
    </PreactRouter>
  );
}

function start() {
  render(<App />, document.querySelector("main") || document.body);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
